import React, {useEffect, useState} from "react";
import BlogListItem from "./BlogListItem";

import 'assets/css/BlogListings.min.css';
import req from "functions/req";
import settings from "configs/settings";
import clg from "functions/log";

const BlogListings = ({ blogListItemClasses = null }) => {

    const [posts, setPosts] = useState([
        { title : null, image : null, timestamp : null },
        { title : null, image : null, timestamp : null },
        { title : null, image : null, timestamp : null },
    ]);

    const [loaded, setLoaded] = useState(false);

    const get = () => {
        req({ url : settings.req.blog.get_entries, method : "POST", data : { draft : 0 } }).then(function(res){
            clg("blog-listings res: ", res);
            if( res && res.success ) {
                setPosts(res.data);
                setLoaded(true);
            }
        });
    }

    useEffect(() => {
        get();
    },[])


    return(
        <div className="blog-listings-container container p-0">
            <div className="row">
                {
                    posts.map((curr,index) => (
                        <BlogListItem
                            title={curr.title}
                            image={curr.image}
                            timestamp={ (curr.date ? curr.date.split(" ")[0] : null) }
                            slug={curr.slug || null}
                            loaded={loaded}
                            containerClasses={blogListItemClasses}
                            key={`blog-list-item-${index}`}
                        />
                    ))
                }
            </div>
        </div>
    )
}

export default BlogListings;